import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { brand } from "../../../theme/businessFlowsTheme";

// What an empty list means, and what to do about it.
export default function EmptyState({ icon, title, text, action = null }) {
  return (
    <Stack alignItems="center" spacing={1.25} sx={{ py: 6, px: 2, textAlign: "center", borderRadius: 4, border: `1px dashed ${brand.line}`, bgcolor: "#fff" }}>
      <Box sx={{ width: 48, height: 48, borderRadius: 3, display: "grid", placeItems: "center", bgcolor: brand.canvas, color: brand.ink }}>{icon}</Box>
      <Typography sx={{ fontWeight: 700 }}>{title}</Typography>
      {text && (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
          {text}
        </Typography>
      )}
      {action}
    </Stack>
  );
}
